import styles from './style.module.css'
import { Button } from '../../components';

const NotFound = () => {
    return (
        <div className={styles.not_found__area}>
            <div className={styles.not_found__content}>
                <h1>404</h1>
                <h3>Ой, кажется станица не существует!</h3>
                <h4>Возможно она была удалена или Вы ошиблись...</h4>
                <Button
                    children="Вернуться на главную" 
                    href="/"
                />
            </div>
        </div>
    );
}

export default NotFound;